<template>
  <v-select
    class="search-select-item"
    v-model="filters.themesSelected"
    item-text="name"
    item-value="id"
    :menu-props="{contentClass:'multi-select-search-menu', maxHeight: 'calc(100vh - 24px)' }"
    :label="$t('ARTWORK.THEME')"
    :items="themes"
    :loading="loading"
    clearable
    solo
    flat
    multiple
    hide-details
    return-object
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ $t('ARTWORK.THEME') }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ["filters", "themes", "loading"],

  watch: {
    "filters.themesSelected": {
      handler: function(val) {
        this.$emit("change");
      }
    }
  }
};
</script>
